export default "/assets/webpack-assets/GT-Walsheim-Pro-Regular-Oblique.42947d7442423145b48cb81e70027030.ttf";